import React from 'react';
import * as Styled from './LandingSubheroAreaStyled';
import AdvertisementPropertyLines from "../propertyLines/AdvertisementPropertyLines";

type IProps = {
    frontMatter?: any
}

const LandingSubHeroArea = ({frontMatter}: IProps) => {
    return (
        <React.Fragment>
            <Styled.LandingSubHeroArea>
                <Styled.LandingSubHeroAreaBreadcrumb>
                    {frontMatter?.breadcrumb ? frontMatter.breadcrumb : 'Pembe Panjur > İstanbul > İstanbul Evlilik Sitesi'}
                </Styled.LandingSubHeroAreaBreadcrumb>
                <Styled.LandingSubHeroAreaTitle>
                    {frontMatter?.saying ? frontMatter.saying : 'Bir şehir gibi ol. Mesela İstanbul gibi. De ki hep seveceğim seni.'}
                </Styled.LandingSubHeroAreaTitle>
                <Styled.LandingSubHeroAreaDescription>
                    <AdvertisementPropertyLines icon={frontMatter?.propertyTopImg} title={frontMatter?.propertyTopTitle} content={frontMatter?.propertyTopContent}/>
                    <AdvertisementPropertyLines icon={frontMatter?.propertyMiddleImg} title={frontMatter?.propertyMiddleTitle} content={frontMatter?.propertyMiddleContent}/>
                    <AdvertisementPropertyLines icon={frontMatter?.propertyBottomImg} title={frontMatter?.propertyBottomTitle} content={frontMatter?.propertyBottomContent}/>
                </Styled.LandingSubHeroAreaDescription>
            </Styled.LandingSubHeroArea>
        </React.Fragment>

    );
}

export default LandingSubHeroArea;
